module.exports = __webpack_public_path__ + "img/icrt.aa70a6a3.png";